import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { alpha } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';
import { NAVY } from 'styles/tokens';

interface InfoItemProps {
  label: string;
  value: React.ReactNode;
  fullWidth?: boolean;
}

const InfoItem: React.FC<InfoItemProps> = ({ label, value, fullWidth = false }) => {
  const displayValue = value || '-';
  const isReactElement = React.isValidElement(displayValue);
  const stringValue = isReactElement ? '' : String(displayValue);
  const shouldTruncate = !isReactElement && stringValue.length > 50;

  return (
    <Grid size={fullWidth ? 12 : 6}>
      <Box
        sx={{
          mb: 0.5,
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{
            color: alpha(NAVY, 0.5),
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            fontSize: '0.65rem',
          }}
        >
          {label}
        </Typography>
        {shouldTruncate ? (
          <Tooltip title={stringValue} arrow placement="top">
            <Typography
              variant="body2"
              component="div"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                cursor: 'default',
                maxWidth: '100%',
                color: NAVY,
              }}
            >
              {displayValue}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            variant="body2"
            sx={{
              wordBreak: 'break-word',
              overflowWrap: 'anywhere',
              maxWidth: '100%',
              color: NAVY,
            }}
            component="div"
          >
            {displayValue}
          </Typography>
        )}
      </Box>
    </Grid>
  );
};

export default InfoItem;
